function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g887",
    transform: "matrix(0.99964629,0,0,1.0003432,5.2324025e-5,-3.9216372e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18584",
    style: {
      fill: "#c2e7eb",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313114px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 4.0788006,0.11239898 1.10413,0.92658352 M 0.15026915,0.14901616 H 4.0265182 V 1.0756115 h 1.10413 v 5.372701 H 0.15026915 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g876"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.195265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 1.0380226,1.6162981 H 2.8146235",
    id: "path21260"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.195265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 1.0380226,2.2282906 H 2.8146235",
    id: "path21262"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.195265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 1.0380226,2.840283 H 4.0822124",
    id: "path21264"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.195265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 1.0380226,3.4522755 H 2.8146235",
    id: "path21266"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.195265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 1.5992464,4.0642679 h 2.482966",
    id: "path21268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.195265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 1.0380226,4.6762604 H 4.0822124",
    id: "path21270"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.195265,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 1.0380226,5.2882528 H 2.8146235",
    id: "path21272"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextOn);
export default __webpack_public_path__ + "static/media/text_on.850591f4b48d440c595a60377b495727.svg";
export { ForwardRef as ReactComponent };